module.exports = __webpack_public_path__ + "img/warning-email-failed.492b74ed.svg";